export default __webpack_public_path__ + "static/media/tool_item_1.fdd11902.png";